import { Header, Footer, HeaderProps, FooterProps } from '../../components';
import React from 'react';
import { Body, BodyProps, Grid, GridProp } from '../surfaces';

export type LayoutProps = {
  children: React.ReactNode;
  header?: HeaderProps;
  footer?: FooterProps;
  body?: BodyProps;
  grid?: GridProp;
  removeGrid?: boolean;
  beforeGrid?: React.ReactNode;
  afterGrid?: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = ({
  children,
  header,
  footer,
  body,
  grid,
  beforeGrid,
  removeGrid,
  afterGrid,
}) => {
  return (
    <Body {...body} className=''>
      <Header {...header} />
      {beforeGrid}
      {removeGrid ? children : <Grid {...grid}>{children}</Grid>}
      {afterGrid}
      <Footer {...footer} />
    </Body>
  );
};
